export const LOADING_PLACEHOLDER = '...';
